import React, { useEffect, useRef, useState } from "react";
import logoImg from "../../assets/images/logo.png";
import { Offcanvas } from "bootstrap";
import { candidateAcceptRoadTest, candidateInterested, candidateNotInterested, fetchCandidateDetails } from "model/CandidateDetailsModel";
import { useUserContext } from "libs/context/UserContext";
import CandidateConversationModal from "pages/CandidateConversationModal/candidate-conversation-model";
import CandidateTrackApplication from "pages/CandidateTrackApplication/candidate-track-application";
import { formatDataBeforeSend } from "helpers/GeneralHelper";
import { toast, ToastContainer } from "react-toastify";
import { Button, FormGroup, Input, Label, Modal, ModalBody, Spinner } from "reactstrap";
import * as Yup from "yup";
import NotInterestedCommonButton from "pages/NotInterestedCommonButton/not-interested-common-button";





const CandidateJobSection = ({ setActiveTab }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { loading, candidateDetailsData, fetchCandidateDetailsDataForUpdate, loadingDetails, fetchCandidateDetailsData } = useUserContext() || {};
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitLoadingReject, setSubmitLoadingReject] = useState(false);
    if (candidateDetailsData?.Interested) {
        localStorage?.setItem("InterestedOrNot", "Interested")
    }
    // else{
    //     localStorage?.setItem("InterestedOrNot", "Not-Interested")  
    // }

    const offcanvasRef = useRef(null);
    const offcanvasInstanceRef = useRef(null);
    const inputFields = {
        Notes: ''
    };
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const formatOptions = [];
    const [fields, setFields] = useState(inputFields);

    const inputFieldsInterested = {

    };

    const formatOptionsInterested = [];
    const [fieldsInterested, setFieldsInterested] = useState(inputFieldsInterested);
    const [interestedNotes, setNotInterestedNotes] = useState(false);

    const InterestedOrNot = localStorage?.getItem("InterestedOrNot")
    const [InterestedValue, setInterested] = useState(false);


    // useEffect(() => {
    //     if (offcanvasRef.current) {
    //         offcanvasInstanceRef.current = new Offcanvas(offcanvasRef.current);
    //     }
    // }, []);
    useEffect(() => {
        if (offcanvasRef.current) {
            offcanvasInstanceRef.current = new Offcanvas(offcanvasRef.current, {
                backdrop: true,   // keeps backdrop
                scroll: true,     // allow body scroll
                keyboard: true    // close on ESC
            });
        }
    }, []);

    const openOffcanvas = () => {
        offcanvasInstanceRef.current?.show();
    };
    const closeModal = () => setNotInterestedNotes(false);




    // start---->this one for the text see more and see less section
    const toggleText = () => setIsExpanded(!isExpanded);
    const jobDescription = candidateDetailsData?.Client?.JobDescription || "";
    // Split into words (ignores extra spaces/newlines)
    const words = jobDescription.split(/\s+/);
    const maxWords = 350;
    const isLongText = words.length > maxWords;
    const truncatedText = words.slice(0, maxWords).join(" ");
    const displayedText = isExpanded
        ? jobDescription
        : `${truncatedText}...`;
    // end---->this one for the text see more and see less section


    const interrestedOrNot = async (e, status) => {
        e.preventDefault();
        setSubmitLoading(true);

        try {
            const formData = formatDataBeforeSend(fieldsInterested, inputFieldsInterested, formatOptionsInterested);
            formData.append('CandidateClientId', candidateDetailsData?.CandidateClientId)
            let response = await candidateInterested(formData)
            if (response?.IsSuccess) {
                toast.success(response?.Message);
                localStorage?.setItem("InterestedOrNot", "Interested")
                setSubmitLoading(false);
                setSubmitLoadingReject(false)
                fetchCandidateDetailsDataForUpdate()
            } else {
                toast.error("Failed to update");
            }
        } catch (err) {
            toast.error(err);
        } finally {
            setSubmitLoading(false);
            setSubmitLoadingReject(false)
        }
    };

    // i will not interested section

    // ✅ Yup validation schema
    const validationSchema = Yup.object().shape({
        Notes: Yup.string().required("Notes are required"),
    });

    // Handle input change + validate field
    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });

        try {
            await Yup.reach(validationSchema, name).validate(value);
            setErrors((prev) => ({ ...prev, [name]: "" }));
        } catch (err) {
            setErrors((prev) => ({ ...prev, [name]: err.message }));
        }
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched({ ...touched, [name]: true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoadingReject(true);

        try {
            await validationSchema.validate(fields, { abortEarly: false });
            setErrors({});

            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
            formData.append('CandidateClientId', candidateDetailsData?.CandidateClientId)
            let response = await candidateNotInterested(formData)

            if (response?.IsSuccess) {
                toast.success(response?.Message);
                localStorage?.setItem("InterestedOrNot", "Not-Interested")
                setFields(inputFields);
                fetchCandidateDetailsData()
                closeModal();
                setFields(inputFields);
                setSubmitLoadingReject(false)
            } else {
                setSubmitLoadingReject(false)
                toast.error("Failed to submit callback request");
            }
        } catch (err) {
            setSubmitLoadingReject(false)
            toast.error(err);
        } finally {
            setSubmitLoadingReject(false);
        }
    };

    useEffect(() => {
        setInterested(false)
        if (InterestedOrNot == 'Not-Interested') {
            setInterested(false)
        }
        else if (InterestedOrNot == 'Interested') {
            setInterested(true)
        }
    }, [InterestedOrNot]);


    return (
        <>
            {(loadingDetails || submitLoading || submitLoadingReject) ? (
                <div className="text-center py-5">
                    <Spinner color="primary" /> Loading...
                </div>
            ) :
                (
                    <>
                        <div className="left-dynamic-content px-lg-5 px-2">
                            <div className="view-profile-desktop">
                                <div className="d-flex flex-column flex-md-row justify-content-between mb-4 gap-2 gap-md-0 border-bottom pb-3">
                                    <div className="sec-title">
                                        <h2 className="mb-1">{candidateDetailsData?.CandidateFName} {candidateDetailsData?.CandidateLName}</h2>
                                        <p>{candidateDetailsData?.CandidateEmail}</p>
                                        <p>{candidateDetailsData?.JobTitle}</p>
                                    </div>

                                    <div className="user-account d-flex flex-column align-items-center gap-2">
                                        <button className="btn btn-primary-2" onClick={() => setActiveTab("personal")}>View Profile</button>
                                       {/* <h6>{candidateDetailsData?.JobTitle}</h6> */}
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 gx-5 gy-3" id="details-card-desktop">
                                {/* <div className="col-12">
                            <div className="card video-frame border-0 mb-3">
                                <div className="card-header pt-3 border-bottom-0 bg-transparent">
                                    <h5 className="card-title mb-0">Important Informations</h5>
                                </div>
                                <div className="card-body d-flex gap-2 justify-content-between align-items-center pt-0">
                                    <ul>
                                        <li>Contractor Name: OS Enterprises II Inc</li>
                                        <li>Terminal Address: 9935 Doerr Ln, Schertz, TX 78154</li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}

                                {candidateDetailsData?.Client?.Payment?.Childs?.length ?
                                    <div className="col-12">
                                        <div className="card details-card">
                                            <div className="card-body">
                                                <div className="d-flex gap-2">
                                                    <div className="icon d-flex flex-column text-center me-1 align-self-start">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                                            className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                            <path
                                                                d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                            <path
                                                                d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                        </svg>
                                                    </div>
                                                    <div className="d-flex flex-column w-100">
                                                        <div className="details border-bottom mb-2 pb-2">
                                                            <h4>
                                                                {/* Starting pay with $135/day and can earn upto $150/Day depending on experience */}
                                                                {candidateDetailsData?.Client?.Payment?.Head}
                                                            </h4>
                                                        </div>
                                                        <ul>
                                                            {candidateDetailsData?.Client?.Payment?.Childs?.map((payment, i) => (

                                                                <li className="text-dark" key={i}>{payment?.Title}: {payment?.Value}</li>
                                                            ))}
                                                            {/* <li className="text-dark">Payday: Friday</li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null
                                }
                                {candidateDetailsData?.Client?.Schedule?.Childs?.length ?
                                    <div className="col-12">
                                        <div className="card details-card">
                                            <div className="card-body">
                                                <div className="d-flex gap-2">
                                                    <div className="icon d-flex flex-column text-center me-1 align-self-start">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                                            className="bi bi-calendar3" viewBox="0 0 16 16">
                                                            <path
                                                                d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                            <path
                                                                d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                        </svg>
                                                    </div>
                                                    <div className="d-flex flex-column w-100">
                                                        <div className="details border-bottom mb-2 pb-2">
                                                            <h4>
                                                                {/* 7-9 Hours */}
                                                                {candidateDetailsData?.Client?.Schedule?.Head}
                                                            </h4>
                                                        </div>
                                                        <ul>
                                                            {/* <li className="text-dark">Pay Structure: Flat daily pay</li> */}
                                                            {candidateDetailsData?.Client?.Schedule?.Childs?.map((schedule, i) => (

                                                                <li className="text-dark" key={i}>{schedule?.Title}: {schedule?.Value}</li>
                                                            ))}
                                                            {/* <li className="text-dark">Payday: Friday</li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>

                            {/* <!-- Mobile cards --> */}
                            <div className="row mb-4 g-3 logo-with-card" id="details-card-mob">
                                {/* <div className="col-12">
                            <div className="text-center">
                                <img src={logoImg} className="img-fluid" />
                            </div>
                        </div> */}
                                <div className="col-12">
                                    <div className="card name-details p-3 bg-light-gray border-0 mb-3">
                                        <div className="card-body d-flex gap-2 justify-content-between align-items-center">
                                            <div className="d-flex flex-column">
                                                <h5 className="card-title mb-0">{candidateDetailsData?.CandidateFName} {candidateDetailsData?.CandidateLName}</h5>
                                                <p className="card-text">{candidateDetailsData?.CandidateEmail}</p>
                                                <p className="card-text">
                                                    {/* Position Applied for: FedEx Delivery Driver */}
                                                    {candidateDetailsData?.JobTitle}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                        <div className="active-mob-device d-xl-none">
                                            <button className="btn btn-primary-2 btn-callback-mob"
                                                type="button"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#application_status"
                                                aria-controls="application_status"
                                                onClick={openOffcanvas}
                                            >
                                                Track Application
                                            </button>

                                        </div>
                                    {/* // } */}
                                    <hr />
                                </div>
                            </div>

                            {/* <!-- Accordion section --> */}
                            <div className="row mb-4 g-3" id="details-card-mob">
                                <div className="col-12">
                                    <div className="accordion" id="accordionExample">
                                        {candidateDetailsData?.Client?.Payment?.Head ?
                                            <div className="accordion-item details-card">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button
                                                        className="accordion-button collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                    >
                                                        <div
                                                            className="card-header d-flex align-items-center"
                                                        >
                                                            <div
                                                                className="icon d-flex flex-column text-center me-2"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-wallet"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a2 2 0 0 1-1-.268M1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1"
                                                                    />
                                                                </svg>
                                                                {/* <!-- <p className="text-dark">Payment</p> --> */}
                                                            </div>
                                                            <div className="details">
                                                                <h4>
                                                                    {/* Payment: $150/day */}
                                                                    {candidateDetailsData?.Client?.Payment?.Head}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </h2>
                                                <div
                                                    id="collapseOne"
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby="headingOne"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="card-body p-0">
                                                            <ul>
                                                                {candidateDetailsData?.Client?.Payment?.Childs?.map((payment, i) => (

                                                                    <li key={i}>{payment?.Title}: {payment?.Value}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : null
                                        }
                                        {candidateDetailsData?.Client?.Schedule?.Head &&
                                            <div className="accordion-item details-card">
                                                <h2 className="accordion-header" id="headingTwo">
                                                    <button
                                                        className="accordion-button collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseTwo"
                                                        aria-expanded="false"
                                                        aria-controls="collapseTwo"
                                                    >
                                                        <div
                                                            className="card-header d-flex align-items-center"
                                                        >
                                                            <div
                                                                className="icon d-flex flex-column text-center me-2"
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-calendar3"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path
                                                                        d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z"
                                                                    />
                                                                    <path
                                                                        d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                                                                    />
                                                                </svg>
                                                            </div>
                                                            <div className="details">
                                                                <h4>
                                                                    {/* Schedule: 10 Hours */}
                                                                    {candidateDetailsData?.Client?.Schedule?.Head}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </h2>
                                                <div
                                                    id="collapseTwo"
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby="headingTwo"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="card-body">
                                                            <ul>
                                                                {/* <li>Start time: 09:15</li>
                                                            <li>Miles Driven each day: 50 -70</li>
                                                            <li>Work Schedules: Monday to Saturday</li>
                                                            <li>
                                                                Additional Information: Minimum 10 Hours a
                                                                day is a must
                                                            </li> */}
                                                                {candidateDetailsData?.Client?.Schedule?.Childs?.map((payment, i) => (

                                                                    <li key={i}>{payment?.Title}: {payment?.Value}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Videos --> */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card video-frame border-0 mb-3">
                                        <div className="card-header py-3 border-bottom bg-transparent">
                                            <h5 className="card-title mb-0">
                                                {/* A day in the life of a FedEx Ground ISP driver */}
                                                {candidateDetailsData?.Client?.JobCategoryVideoTitle}
                                            </h5>
                                        </div>
                                        <div className="card-body d-flex gap-2 justify-content-between align-items-center">
                                            <iframe width="100%" height="315" src={candidateDetailsData?.Client?.JobCategoryVideoLink || "https://www.youtube.com/embed/VJsA_JheWDk?si=O2jJgo4pEn0nFNCK"}
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin" allowfullScreen>
                                            </iframe>
                                        </div>
                                    </div>
                                    <hr />
                                </div>

                                <div className="col-12">
                                    <div className="card video-frame border-0 mb-3">
                                        <div className="card-header py-3 border-bottom bg-transparent border-bottom-clr">
                                            <h5 className="card-title mb-0">Job Description</h5>
                                        </div>
                                        <div className="card-body d-flex gap-2 justify-content-between align-items-center">
                                            <div>
                                                <p dangerouslySetInnerHTML={{ __html: displayedText }} />
                                                {isLongText && (
                                                    <span
                                                        id="toggle-btn"
                                                        className="see-more-btn text-blue-600 font-medium hover:underline cursor-pointer "
                                                        onClick={toggleText}
                                                    >
                                                        {isExpanded ? "See Less" : "See More"}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Benefits desktop --> */}
                            {candidateDetailsData?.Client?.Benefits?.length ?
                                <div className="row mb-4" id="benefits-desktop-view">
                                    <div className="col-12">
                                        <div className="benefit-tab-wrapper">
                                            <div className="d-flex align-items-start">
                                                {/* Tabs */}
                                                <ul
                                                    className="nav nav-pills mb-3 justify-content-center flex-column"
                                                    id="benefits-tab"
                                                    role="tablist"
                                                >
                                                    {candidateDetailsData?.Client?.Benefits?.map((benefit, i) => (
                                                        <li className="nav-item" role="presentation" key={i}>
                                                            <button
                                                                className={`nav-link ${i === 0 ? "active" : ""}`}
                                                                id={`pills-${i}-tab`}
                                                                data-bs-toggle="pill"
                                                                data-bs-target={`#pills-${i}`}
                                                                type="button"
                                                                role="tab"
                                                                aria-controls={`pills-${i}`}
                                                                aria-selected={i === 0 ? "true" : "false"}
                                                            >
                                                                {benefit?.Title}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>

                                                {/* Tab Content */}
                                                <div className="tab-content" id="benefits-tabContent">
                                                    {candidateDetailsData?.Client?.Benefits?.map((benefit, i) => (
                                                        <div
                                                            key={i}
                                                            className={`tab-pane fade ${i === 0 ? "show active" : ""}`}
                                                            id={`pills-${i}`}
                                                            role="tabpanel"
                                                            aria-labelledby={`pills-${i}-tab`}
                                                        >
                                                            <p>{benefit?.Value}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                            }


                            {/* <!-- Benefits mobile --> */}
                            {candidateDetailsData?.Client?.Benefits?.length ?
                                <div className="row mb-4" id="benefits-mob-view">
                                    <div className="col-12">
                                        <div className="common-wrapper">
                                            <h5 className="pb-1">Benefits</h5>

                                            <div className="row mt-1 g-3">
                                                {candidateDetailsData?.Client?.Benefits?.map((benefit, i) => (
                                                    <div className="col-md-6 col-12" key={i}>
                                                        <div className="card benefit-card">
                                                            <div className="row g-0 align-items-stretch h-100">
                                                                {/* Left: Title */}
                                                                <div className="col-4">
                                                                    <div className="card-desc bg-lightblue">
                                                                        <p>{benefit?.Title}</p>
                                                                    </div>
                                                                </div>

                                                                {/* Right: Description */}
                                                                <div className="col-8">
                                                                    <div className="card-body bg-gray">
                                                                        <p className="card-text">{benefit?.Value}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                            }


                            <hr />
                            {(!candidateDetailsData?.Interested || !localStorage?.getItem("InterestedOrNot")) &&
                                <>
                                    <div className="plan-features mt-5 text-center">
                                        <div className="form-check d-inline-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                id="termsCheckbox"
                                                checked={true}
                                                disabled={true}
                                            />
                                            <label className="form-check-label" htmlFor="termsCheckbox">
                                                I agree to the <a href="#" className="text-warning">Terms and Conditions</a>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-center gap-3 mt-3">
                                        <button className="btn btn-outline-dark px-4" onClick={(e) => setNotInterestedNotes(true)}>I WILL PASS</button>
                                        <button className="btn btn-dark px-4" onClick={(e) => interrestedOrNot(e, 'interested')}>I AM INTERESTED</button>
                                    </div>

                                    <Modal
                                        isOpen={interestedNotes}
                                        toggle={closeModal}
                                        backdrop="static"
                                        centered

                                    >
                                        <ModalBody className="p-4 d-flex flex-column" style={{ maxHeight: "95vh", overflowY: "auto" }}                                    >
                                            {/* Header */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="fw-bold mb-0">Not Interested Anymore</h5>
                                                <Button close onClick={closeModal} />
                                            </div>

                                            {/* Form */}
                                            <form onSubmit={handleSubmit} className="flex-grow-1 d-flex flex-column">
                                                <div className="flex-grow-1 overflow-auto pe-2">
                                                    <FormGroup>
                                                        <Label>Feedback</Label>
                                                        <Input
                                                            type="textarea"
                                                            name="Notes"
                                                            placeholder="Enter Feedback"
                                                            value={fields.Notes}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {(touched.Notes || errors.Notes) && (
                                                            <div className="text-danger small">{errors.Notes}</div>
                                                        )}
                                                    </FormGroup>
                                                </div>

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-end gap-2 mt-3">
                                                    <Button color="secondary" onClick={closeModal} type="button">
                                                        Cancel
                                                    </Button>
                                                    <Button color="dark" type="submit" disabled={submitLoading}>
                                                        {submitLoading ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Submitting...
                                                            </>
                                                        ) : (
                                                            "Submit"
                                                        )}
                                                    </Button>
                                                </div>
                                            </form>
                                        </ModalBody>
                                    </Modal>
                                </>
                            }

                        </div>
                        {candidateDetailsData?.Interested &&
                            <NotInterestedCommonButton />
                        }

                        <CandidateTrackApplication offcanvasRef={offcanvasRef} offcanvasInstanceRef={offcanvasInstanceRef} />
                    </>
                )
            }
        </>
    );
};

export default CandidateJobSection;
